module.exports = __webpack_public_path__ + "static/bannerVideo-c4851459c096dfd2a957e0fe0f28a90a.webm";